module.exports = __webpack_public_path__ + "static/media/34DSS7.9d8a9cdc.jpg";